import React from "react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <div className="font-display text-xl gold-fill">CROWN ARTISAN DESIGNS</div>
          <p className="text-white/40 text-sm mt-1">Custom luxury homes, built as art.</p>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-8 text-sm text-white/60">
          <a href="tel:+18179321473" className="link-gold">817 932 1473</a>
          <a href="mailto:dusty@crownfw.com" className="link-gold">dusty@crownfw.com</a>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-8 pt-6 border-t border-white/5 text-center text-white/30 text-xs tracking-wider">
        © {new Date().getFullYear()} Crown Artisan Designs. All rights reserved.
      </div>
    </footer>
  );
}
